/**
 * Created by eladd on 08/31/2017.
 */
import {Directive, ElementRef, NgZone, OnInit} from "@angular/core";

@Directive({
	selector: 'input:not([type])[cpSelectContent], input[type=text][cpSelectContent]'
})
export class SelectContentDirective implements OnInit {
	constructor(
		protected ngZone: NgZone,
		protected elementRef: ElementRef
	) { }

	ngOnInit() {
		this.ngZone.runOutsideAngular(() =>
			setTimeout(() =>
				this.elementRef.nativeElement.select()
			)
		);
	}
}
